(function (ws) {
    'use strict';

    ws.views.customerOnboardingLockedModalView = ws.views.modal.extend({

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
            this.template = _.template(this.$('#customer-onboarding-locked-content').html());
        },

        /**
         * On Modal Open
         */
        onOpen: function(data) {
            if (this.isAlreadyOpen()) {
                console.debug('Modal ID: ' + this.modalId + ' is already opened.');
                return;
            }

            //check if the modal is being opened by API REST update with data response
            if (data) {
                this.$el.find('.modal-body p').html(this.template(data));
            }

            this.trigger('onOpen');
            this.render();
        }

    });
}(westcon));
